import { tns } from "tiny-slider/src/tiny-slider"

export class SliderV2Component {
    
  constructor(selector) {

      if(document.querySelector(selector)) {
        
        let slider = tns({
          container: document.querySelector(selector),
          mode: "gallery",
          items: 4,
          controls: false,
          pagination: false,
          slideBy: 1,
          mouseDrag: true,
          swipeAngle: false,
          speed: 400,
          nav: false
        });
      }
    }
}





// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/slider/slider-v2.component.js